import { DomainStatusEnum } from '../models/Domain';

export const descriptionMap: { [key: string]: string } = {
  [DomainStatusEnum.Waiting]: 'waiting to connect',
  [DomainStatusEnum.Checking]: 'checking connection',
  [DomainStatusEnum.Failed]: 'failed',
  [DomainStatusEnum.Succeeded]: 'succesfully connected'
};
